<script>
import { mapGetters } from 'vuex';
import { isWorkspaceV2Path } from 'dashboard/helper/workspaceV2';
import { taskNotificationRoute } from 'dashboard/helper/taskNotificationRoute';
import { useTrack } from 'dashboard/composables';
import TableFooter from 'dashboard/components/widgets/TableFooter.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

import NotificationTable from './NotificationTable.vue';

import { ACCOUNT_EVENTS } from '../../../../helper/AnalyticsHelper/events';
export default {
  components: {
    NotificationTable,
    TableFooter,
    NextButton,
  },
  data() {
    return {
      loadError: false,
      requestToken: 0,
      isUnmounted: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      meta: 'notifications/getMeta',
      records: 'notifications/getNotifications',
      uiFlags: 'notifications/getUIFlags',
    }),
    notificationPage() {
      const page = Number(this.$route.query.page);
      return Number.isInteger(page) && page > 0 ? page : 1;
    },
    notificationRouteState() {
      return `${this.$route.params.accountId}:${this.notificationPage}`;
    },
  },
  watch: {
    notificationRouteState: {
      immediate: true,
      handler() {
        this.fetchNotifications();
      },
    },
  },
  beforeUnmount() {
    this.isUnmounted = true;
  },
  methods: {
    fetchNotifications() {
      const requestToken = this.requestToken + 1;
      this.requestToken = requestToken;
      this.loadError = false;
      this.$store
        .dispatch('notifications/get', { page: this.notificationPage })
        .then(result => {
          if (this.isUnmounted || requestToken !== this.requestToken) return;
          this.loadError = result === false;
        });
    },
    onPageChange(page) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: String(page),
        },
      });
    },
    openConversation(notification) {
      const {
        primary_actor_id: primaryActorId,
        primary_actor_type: primaryActorType,
        primary_actor: { id: conversationId },
        notification_type: notificationType,
      } = notification;

      useTrack(ACCOUNT_EVENTS.OPEN_CONVERSATION_VIA_NOTIFICATION, {
        notificationType,
      });
      this.$store.dispatch('notifications/read', {
        id: notification.id,
        primaryActorId,
        primaryActorType,
        unreadCount: this.meta.unreadCount,
      });

      this.$router.push(
        taskNotificationRoute(notification, this.$route) ||
          `/app/accounts/${this.accountId}/${isWorkspaceV2Path(this.$route.path) ? 'v2/' : ''}conversations/${conversationId}`
      );
    },
    onMarkAllDoneClick() {
      useTrack(ACCOUNT_EVENTS.MARK_AS_READ_NOTIFICATIONS);
      this.$store.dispatch('notifications/readAll');
    },
  },
};
</script>

<template>
  <div data-testid="page-notifications" class="h-full overflow-y-auto">
    <div class="flex flex-col h-full">
      <NotificationTable
        v-if="!loadError"
        :notifications="records"
        :is-loading="uiFlags.isFetching"
        :is-updating="uiFlags.isUpdating"
        :on-click-notification="openConversation"
        :on-mark-all-done-click="onMarkAllDoneClick"
      />
      <TableFooter
        v-if="!loadError && !uiFlags.isFetching"
        class="shrink-0 border-t border-n-weak"
        :current-page="Number(meta.currentPage)"
        :total-count="meta.count"
        :page-size="15"
        @page-change="onPageChange"
      />
      <div
        v-if="loadError"
        class="flex flex-col items-center justify-center gap-3 h-full"
      >
        <p role="alert" class="text-sm text-n-slate-11">
          {{ $t('NOTIFICATIONS_PAGE.LIST.LOAD_ERROR') }}
        </p>
        <NextButton
          :label="$t('AGENT_MGMT.LIST.RETRY')"
          icon="i-ph-arrow-clockwise"
          @click="fetchNotifications"
        />
      </div>
    </div>
  </div>
</template>
